export default __webpack_public_path__ + "media/62ef87ede0ea0e01e7c7b389aebbb85a16187828eb2ff5e2017b94d2af80146b.svg";